import React from 'react';
import { Box, Container, Typography, Paper } from '@mui/material';
import CancellationPoliciesTable from '../components/cancellation-policies/CancellationPoliciesTable';

const CancellationPolicies = () => {
  return (
    <Container maxWidth="xl">
      <Box sx={{ my: 0 }}>
        
        <Typography variant="h4"  fontWeight="bold">Cancellation Policies</Typography>
        
        <Paper sx={{ p: 0, mt: 0 }}>
          <CancellationPoliciesTable />
        </Paper>
      </Box>
    </Container>
  );
};

export default CancellationPolicies;
